import { graphql } from 'react-apollo'
import { CREATE_COMMENT } from '../../graphql/mutations'

export default graphql(CREATE_COMMENT, { name: 'createComment' })
